import { IntRange } from '../../../sharedInterface/arrayOfNumbers'

import IPicture from '../Picture/interface'

export type IImageRatio = '16x9' | '4x3' | '1x1' | '3x4' | '9x16'

export interface IAspect {
  mobile?: IImageRatio
  tablet?: IImageRatio
  desktop?: IImageRatio
}
export const pixelLayoutCount = 11

export default interface IProps extends IPicture {
  pixelLayout?: IntRange<1, 12>
  usePixelMask?: boolean
  aspect?: IAspect
  caption?: string
  dataType?: string
}
